import { useState } from 'react';
import styled from 'styled-components';
import { Box, ClickAwayListener } from '@mui/material';
import _ from 'lodash';

//theme
import { colors } from '../../../../theme';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { setPlan } from '../../../../store/reducers/term-planner';

interface DropdownProps {
    active: boolean;
}

const StatusCell = (props) => {
    const { data } = props;

    const termPlannerState = useAppSelector((state) => state.termPlanner);

    const dispatch = useAppDispatch();

    const status: any = termPlannerState.statuses.find((s: any) => s.id === data.statusId);
    let statusName = 'N/A';
    if (status) statusName = status.name;

    const [active, setActive] = useState(false);

    const handleStatusChange = (status: any) => {
        const termPlan = _.cloneDeep(termPlannerState.termPlan);
        const termPlanItemIndex = termPlan.items.findIndex((item) => item.id === data.id);

        termPlan.items[termPlanItemIndex].statusId = status.id;

        dispatch(setPlan(termPlan));
    };

    return (
        <>
            <ClickAwayListener
                onClickAway={() => {
                    setActive(false);
                }}
            >
                <div
                    className={`${statusName === 'Cancelled' ? 'text-red' : statusName === 'Active Online' ? 'text-blue' : statusName === 'Active Distance' && 'text-green'}`}
                    style={{
                        width: '98px',
                        margin: '0 auto 0 0',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        setActive(true);
                    }}
                >
                    &#9679; {statusName}
                </div>
            </ClickAwayListener>

            <DropdownBox active={active}>
                <DropdownBorder>
                    {termPlannerState.statuses.map((s: any) => {
                        return (
                            <>
                                <StateOption className="text-blue" onClick={() => handleStatusChange(s)}>
                                    {s.name}
                                </StateOption>
                            </>
                        );
                    })}
                </DropdownBorder>
            </DropdownBox>
        </>
    );
};

export default StatusCell;

const DropdownBox = styled.div<DropdownProps>`
    display: ${(props) => (props.active ? 'flex' : 'none')};
    position: absolute;
    bottom: -74px;
    left: 0px;
    right: 0px;
    justify-content: left;
    padding: 8px 0px;
    z-index: 999;
    margin: 0 auto;
`;

const DropdownBorder = styled.div`
    background-color: ${colors.white};
    border: 1px solid ${colors.blue.main};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
`;

const StateOption = styled.div`
    width: 120px;
    display: inline-block;
    cursor: pointer;

    & > .active {
        color: ${colors.blue};
    }

    & > .cancelled {
        color: ${colors.red};
    }

    .distance {
        color: ${colors.green};
    }

    &:hover {
        background-color: ${colors.grey.light};
    }
`;
